import { useEffect } from 'react';

function NotFound({ setError }: { setError: (error: any) => void }) {
    useEffect(() => {
        setError({
            status: 404,
            message: 'Page not found',
        });
    }, [setError]);

    return null;
}

export default NotFound;
